'use client';

import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { useQuery } from '@tanstack/react-query';
import { twMerge } from 'tailwind-merge';
import { curatorQueries } from '../../query-factory';
import { GenerateProductLink } from './EarningsBoostItem/GenerateProductLink';
import { JoinCampaignLink } from './EarningsBoostItem/JoinCampaignLink';
import { ManageCurationShopLink } from './EarningsBoostItem/ManageCurationShopLink';

interface EarningsBoostGroupProps {
  className?: string;
}

export const EarningsBoostGroup = ({ className }: EarningsBoostGroupProps) => {
  const { service } = useDeviceInfo();
  const { data: mypageData } = useQuery(curatorQueries.mypage.data());
  const recruitingCampaignCount = mypageData?.recruitingCampaignCount ?? 0;

  return (
    <div className={twMerge('flex flex-col', className)}>
      {service === SERVICE.MUSINSA ? (
        <>
          <ManageCurationShopLink.LinkMusinsa />
          <GenerateProductLink.LinkMusinsa />
        </>
      ) : (
        <>
          <ManageCurationShopLink.Link29cm />
          <GenerateProductLink.Link29cm />
        </>
      )}
      {/* SID-4418: 마지막 활동 항목의 추가 pb-12 제거 — 행 자체 py-8(8) 외에 pb-12 가
          더해져 divider 상단 여백이 과도해지던 것을 정정(간격은 항목이 아니라 divider
          컨테이너 py-12 가 책임진다). */}
      <JoinCampaignLink count={recruitingCampaignCount} />
    </div>
  );
};
